<div class="sm-message {{toast?.Type}} sm-toast" 
    [ngClass]="{ 'sm-toast-non-standalone': !standalone }"
    [id]="'Toast:' + toast?.Id">
    <aurora-icon class="status-icon" [icon]="toast?.Icon"></aurora-icon>
    <h4 class="message">{{ toast?.Message }}</h4>
    <div class="subtitle">
        <h5 *ngFor="let subtitle of toast.Subtitles" class="subtitle_entry single_line">
            {{ subtitle.DisplayType ?? subtitle.Type }}: {{ subtitle.Text }}
        </h5>
    </div>
    <div class="details">{{ toast?.Description }}</div>
    <div class="actions">
        <ng-container *ngFor="let link of toast.Links">
            <nav>
                <aurora-link-button class="link" size="small"
                    (click)="onClickLink.emit({ Id: toast.Id, Subtitle: link})">
                    @if (link.Type == 'Download') {
                        Download
                    } @else {
                        Go to {{link.DisplayType ?? link.Type}}: {{link.Text}}
                    }
                </aurora-link-button>
            </nav>
        </ng-container>
    </div>
    <aurora-icon-button *ngIf="!standalone" class="icon-only" icon="times" variant="ghost" size="large"
        aria-label="Dismiss notification" (click)="dismiss.emit($event)"></aurora-icon-button>
</div>